module.exports = __webpack_public_path__ + "img/book-657618_1280.e53667b0.jpg";